/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetCard.vue?vue&type=template&id=7fd513f2&scoped=true"
import script from "./widgetCard.vue?vue&type=script&lang=js"
export * from "./widgetCard.vue?vue&type=script&lang=js"
import style0 from "./widgetCard.vue?vue&type=style&index=0&id=7fd513f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd513f2",
  null
  
)

export default component.exports